import RelationshipMetadata from "../../RelationshipMetadata";

class RoleRoleAccountUserRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "RoleRoleEmployeeRelationshipMetadata";
        this.parentEnterpriseComponent = "Role";
        this.childEnterpriseComponent = "RoleAccountUser";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "RoleUSID";
    }
}

export default RoleRoleAccountUserRelationshipMetadata;